import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { RoomServices as RoomServicesType } from 'shared/api/tours/search'
import { getValidIcon } from 'shared/lib/validateIcon'
import { AppIcon } from 'shared/ui/app-icon'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface RoomServicesProps {
  services: RoomServicesType[]
}

export const RoomServices = ({ services }: RoomServicesProps) => {
  const { t } = useTranslation()

  if (!services?.length) {
    return null
  }

  return (
    <Paper
      padding={[16]}
      radius={16}
      className={s.wrapper}
    >
      <h6 className={clsx(s.title, 'semi-bold-16')}>
        {t('tours_block.room_services')}
      </h6>

      <div className={s.list}>
        {services.map((i) => (
          <div
            key={i.name}
            className={s.service}
          >
            <AppIcon
              id={getValidIcon(i.icon)}
              width={16}
              height={16}
              className={s.icon}
            />
            <div>
              <span className={clsx(s.label, 'medium-14')}>{i.name}</span>
              {i.pay === '1' && (
                <span className={clsx(s.labelPay, 'medium-12')}>
                  {t('tours_block.paid')}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </Paper>
  )
}
